import { QuestionnaireQuestion } from '@/models/gen/graphql';
import { Schema } from '@/utils';

export namespace QuestionFormDefinitions {
  export type Value = Partial<QuestionnaireQuestion>;
  export const initValue: Value = {
    helperText: '',
    questionnaireCategoryId: '',
    questionText: '',
    answerTypeId: '',
  };
  export const validator = Schema((z) =>
    z.object({
      helperText: z.string().min(1, { message: 'Required' }),
      questionnaireCategoryId: z.string().min(1, { message: 'Required' }),
      questionText: z.string().min(1, { message: 'Required' }),
      answerTypeId: z.string().min(1, { message: 'Required' }),
    })
  );
}
